import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

$w.onReady(function () {});

export function btnLogin(event) {
console.log('registered...');
 let email = $w('#email').value;
 let password = $w('#password').value;
    wixUsers.register(email, password)
        .then(() => {
			console.log('registered!');
			wixLocation.to('/createPetition/' + wixUsers.currentUser.id);
			
            wixLocation.to(wixLocation.url);
        });

}